// extracted by mini-css-extract-plugin
export default {"iframeContainer":"preliminary-application-wp-new_iframeContainer__CaxNl","spinnerOverlay":"preliminary-application-wp-new_spinnerOverlay__gHvDB"};